import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { DollarSign } from 'lucide-react';
export function OfferSection() {
  return <section id="precio" className="py-24 bg-slate-800 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-slate-700" data-id="element-122">
      {/* Background radial gradient for focus */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-500/10 via-slate-800 to-slate-800 pointer-events-none" data-id="element-123"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-125">
          <p className="text-2xl md:text-3xl text-white font-medium leading-relaxed mb-8" data-id="element-126">
            Deja de perder tiempo en trabajos que no valoran tu esfuerzo.
            Invierte en la herramienta que te abrirá las puertas de la clase
            media alta en Estados Unidos.
          </p>
        </motion.div>

        <motion.div id="precio" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-slate-900 border-2 border-amber-500 rounded-3xl p-8 md:p-12 shadow-[0_0_60px_rgba(245,158,11,0.2)] max-w-2xl mx-auto" data-id="element-127">
          <div className="uppercase tracking-widest text-amber-500 font-bold text-sm mb-4" data-id="element-128">
            Precio Especial Hoy
          </div>

          <div className="flex items-center justify-center text-slate-500 mb-2 line-through" data-id="element-129">
            <span className="text-2xl font-oswald" data-id="element-130">$47.00</span>
          </div>

          <div className="flex items-center justify-center text-white mb-2" data-id="element-131">
            <DollarSign className="w-10 h-10 text-emerald-400" data-id="element-132" />
            <span className="text-7xl md:text-8xl font-oswald font-bold tracking-tighter text-emerald-400" data-id="element-133">
              6
            </span>
            <span className="text-3xl font-oswald text-emerald-400/70 mt-4" data-id="element-134">
              .39
            </span>
          </div>

          <div className="inline-block bg-emerald-500/15 border border-emerald-500/30 rounded-full px-4 py-1.5 mb-6" data-id="element-135">
            <span className="text-emerald-400 font-bold text-sm uppercase tracking-wide" data-id="element-136">
              🔥 Ahorra 86% — Oferta por tiempo limitado
            </span>
          </div>

          <p className="text-slate-400 text-lg mb-10 italic" data-id="element-137">
            (Menos de lo que cuesta un tanque lleno de gasolina para un auto
            pequeño).
          </p>

          <CTAButton href="https://claridaddiaria.com/cart/43058360287298:1" className="w-full md:w-auto text-2xl py-6 px-12" subtext="Recibe acceso instantáneo y comienza tu camino a los $1,500 semanales hoy mismo." data-id="element-138" />

          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-139">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-140">
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" data-id="element-141"></path>
            </svg>
            Pago 100% Seguro y Encriptado
          </div>
        </motion.div>
      </div>
    </section>;
}